import { FormEvent, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PageHeader } from '../../components/layout/page/PageHeader';
import { PageShell } from '../../components/layout/page/PageShell';
import { usePortalState } from './PortalState';

export function PortalFeedbackPage() {
  const { feedbackId } = useParams();
  const { data, submitFeedback } = usePortalState();
  const selected =
    data.feedback.find((item) => item.id === feedbackId) ??
    data.feedback.find((item) => !item.submitted) ??
    data.feedback[0];
  const [score, setScore] = useState<number | null>(null);
  const [comment, setComment] = useState('');

  if (!selected) {
    return (
      <PageShell>
        <PageHeader title="Feedback" description="Nenhum pedido de feedback no momento." />
      </PageShell>
    );
  }

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!selected || score == null) return;
    submitFeedback(selected.id, score, comment);
  }

  const scores = Array.from(
    { length: selected.maxScore - selected.minScore + 1 },
    (_, index) => selected.minScore + index,
  );

  return (
    <PageShell variant="form">
      <PageHeader
        title="Feedback"
        description="Responda quando uma entrega ou o ritmo do contrato pedirem a sua avaliação."
      />
      {data.feedback.length > 1 ? (
        <ul className="flex flex-wrap gap-2">
          {data.feedback.map((item) => (
            <li key={item.id}>
              <Link
                to={`/portal/feedback/${item.id}`}
                className={item.id === selected.id ? 'erp-btn-primary erp-btn-sm' : 'erp-btn-secondary erp-btn-sm'}
              >
                {item.submitted ? 'Enviado' : item.title}
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
      <section className="erp-card">
        <div className="erp-card-body">
          {selected.submitted ? (
            <div className="space-y-2">
              <h2 className="erp-card-title">Feedback enviado</h2>
              <p className="text-sm text-secondary-700">
                Nota {selected.score} de {selected.maxScore}. A equipe vê essa resposta no relatório que já usa.
              </p>
              {selected.comment ? <p className="text-sm text-secondary-600">{selected.comment}</p> : null}
              <Link to="/portal" className="inline-block text-sm font-semibold text-primary-700">
                Voltar ao início
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <h2 className="erp-card-title">{selected.title}</h2>
                <p className="mt-2 text-sm text-secondary-600">{selected.context}</p>
              </div>
              <fieldset>
                <legend className="erp-label">{selected.prompt}</legend>
                <div className="mt-2 flex flex-wrap gap-2">
                  {scores.map((value) => (
                    <button
                      key={value}
                      type="button"
                      onClick={() => setScore(value)}
                      className={
                        score === value ? 'erp-btn-primary erp-btn-sm min-w-10' : 'erp-btn-secondary erp-btn-sm min-w-10'
                      }
                    >
                      {value}
                    </button>
                  ))}
                </div>
              </fieldset>
              <div>
                <label className="erp-label" htmlFor="feedback-comment">
                  Comentário
                </label>
                <textarea
                  id="feedback-comment"
                  value={comment}
                  onChange={(event) => setComment(event.target.value)}
                  rows={4}
                  className="mt-1 w-full border border-secondary-300 px-3 py-2 text-sm"
                />
              </div>
              <button type="submit" className="erp-btn-primary" disabled={score == null}>
                Enviar feedback
              </button>
            </form>
          )}
        </div>
      </section>
    </PageShell>
  );
}
